jQuery.noConflict();
(function ($) {
  $(document).ready(function () {
    var data = document.querySelector("#data");

    if (data === null) {
        //console.log('element does NOT exist in DOM');
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting === true) {
            $('.counter').each(function() {
                var $this = $(this),
                    countTo = $this.attr('data-count');
                
                $({ countNum: $this.text()}).animate({
                  countNum: countTo
                },
              
                {
              
                  duration: 3000,
                  easing:'swing',
                  step: function() {
                    $this.text(Math.floor(this.countNum));
                  },
                  complete: function() {
                    $this.text(this.countNum);
                    //alert('finished');
                  }
              
                });  
                
                
              
              });
            observer.unobserve(entries[0].target);
          }
        },
        { threshold: [1] }
      );

      observer.observe(data);
    };
  });
})(jQuery);
